// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const noResult = `<div class="feed-none g-col-12">${__(
  'There were no results!',
  'vn'
)}</div>`

export default noResult
